const css = `@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.loading-screen {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--surface);
  z-index: 999;
  opacity: 0;
  pointer-events: none;
  flex-direction: column;
  transition: opacity 0.3s ease-out;
  position: fixed;
  top: 0;
  left: 0;
}
.loading-screen.loading-screen-show {
  display: flex;
}
.loading-screen.loading-screen-show {
  opacity: 1;
  pointer-events: all;
  display: flex;
}
.loading-screen:not(.loading-screen-show) {
  animation: fadeOut 0.3s ease-out forwards;
}
.loading-screen .loading-logo img {
  width: 90vw;
  max-width: 500px;
  filter: var(--logo-filter);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvTG9hZGluZ1NjcmVlbiIsInNvdXJjZXMiOlsiTG9hZGluZ1NjcmVlbi5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7SUFDRTs7RUFFRjtJQUNFOzs7QUFJSjtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7QUFHRjtFQUNFOztBQUlBO0VBQ0U7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiQGtleWZyYW1lcyBmYWRlT3V0IHtcbiAgZnJvbSB7XG4gICAgb3BhY2l0eTogMTtcbiAgfVxuICB0byB7XG4gICAgb3BhY2l0eTogMDtcbiAgfVxufVxuXG4ubG9hZGluZy1zY3JlZW4ge1xuICBoZWlnaHQ6IDEwMHZoO1xuICB3aWR0aDogMTAwdnc7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBiYWNrZ3JvdW5kOiB2YXIoLS1zdXJmYWNlKTtcbiAgei1pbmRleDogOTk5O1xuICBvcGFjaXR5OiAwO1xuICBwb2ludGVyLWV2ZW50czogbm9uZTtcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgdHJhbnNpdGlvbjogb3BhY2l0eSAwLjNzIGVhc2Utb3V0O1xuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHRvcDogMDtcbiAgbGVmdDogMDtcblxuICAmLmxvYWRpbmctc2NyZWVuLXNob3cge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gIH1cblxuICAmLmxvYWRpbmctc2NyZWVuLXNob3cge1xuICAgIG9wYWNpdHk6IDE7XG4gICAgcG9pbnRlci1ldmVudHM6IGFsbDtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICB9XG5cbiAgJjpub3QoLmxvYWRpbmctc2NyZWVuLXNob3cpIHtcbiAgICBhbmltYXRpb246IGZhZGVPdXQgMC4zcyBlYXNlLW91dCBmb3J3YXJkcztcbiAgfVxuXG4gIC5sb2FkaW5nLWxvZ28ge1xuICAgIGltZyB7XG4gICAgICB3aWR0aDogOTB2dztcbiAgICAgIG1heC13aWR0aDogNTAwcHg7XG4gICAgICBmaWx0ZXI6IHZhcigtLWxvZ28tZmlsdGVyKTtcbiAgICB9XG4gIH1cbn1cbiJdfQ== */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
